
import {
  computed, defineComponent, reactive, ref,
} from 'vue';
import draggable from 'vuedraggable';
import Icone from '@/core/components/UI/Icone.vue';
import { ICaracteristicaItem } from '@/models/Entidades/ICaracteristica';
import SelecionarSimNao from '@/core/components/UI/SelecionarSimNao.vue';
import MensagemSemDados from '@/core/components/UI/MensagemSemDados.vue';
import UtilitarioGeral from '@/core/utilitarios/UtilitarioGeral';
import { useAppBase } from '@/core/composables/AppBase';

export default defineComponent({
  name: 'ItensListaSimples',
  emits: ['update:itensListaSimples'],
  props: {
    codigoCaracteristica: {
      type: Number,
      required: true,
    },
    itensListaSimples: {
      type: Array as () => ICaracteristicaItem[],
      required: true,
    },
  },
  components: {
    draggable,
    Icone,
    SelecionarSimNao,
    MensagemSemDados,
  },
  setup(props, { emit }) {
    const { apresentarMensagemAlerta } = useAppBase();

    const campoNovoValorItem = ref<HTMLElement | null>(null);

    const state = reactive({
      novoValor: '',
    });

    const computedItensListaSimples = computed({
      get: () => props.itensListaSimples,
      set: (val: ICaracteristicaItem[]) => {
        emit('update:itensListaSimples', val);
      },
    });

    function removerItem(index:number) {
      computedItensListaSimples.value.splice(index, 1);
    }

    function defineFocoCampoNovoItem() {
      if (campoNovoValorItem.value) {
        campoNovoValorItem.value.focus();
      }
    }

    function adicionarItem() {
      if (!UtilitarioGeral.valorValido(state.novoValor)) {
        apresentarMensagemAlerta('Por favor, defina um valor para o item!');
        defineFocoCampoNovoItem();
        return;
      }

      const itens = computedItensListaSimples.value;
      const itemCaracteristica:ICaracteristicaItem = {} as ICaracteristicaItem;
      itemCaracteristica.codigo = 0;
      itemCaracteristica.codigoCaracteristica = props.codigoCaracteristica;
      itemCaracteristica.valor = state.novoValor;
      itemCaracteristica.status = true;
      itens.push(itemCaracteristica);
      state.novoValor = '';
      emit('update:itensListaSimples', itens);
    }

    return {
      state,
      computedItensListaSimples,
      campoNovoValorItem,
      removerItem,
      adicionarItem,
    };
  },
});
